export const dealerLocation = "dealerLocation";
export const dealerLocationList = "dealerLocationList";
export const countriesAPI = "countriesAPI";
export const statesAPI = "statesAPI";
export const leadAPI = "salesforceLead";
export const caseAPI = "salesforceCase";
export const searchAPI = "dealerSearch"
export const newBoats = "newBoats";
export const usedBoats = "usedBoats";
export const compareBoats = "compareBoats";
export const featuredInventory = "featuredInventory";
export const boatDetails = "boatDetails";
export const boatModelAPI = "boatModelAPI";
export const newsAPI = "newsAPI";
export const eventsAPI = "eventsAPI";
export const filterBoat = "filterBoat";
export const teamMembersAPI = "teamMembers";
export const createTrader = "createTrader";
export const blackwidowImages = "blackwidowImages";

const config = {
    baseURL: window.API_BASE_URL, //"https://localhost:44302/api/"
    dealerLocation: "DealerLocation?host=",
    dealerLocationList: "DealerLocation/GetList",
    countriesAPI: "Countries",
    statesAPI: "States",
    salesforceLead: "Salesforce/lead",
    salesforceCase: "Salesforce/case",
    dealerSearch: "DealerLocation/search",
    newBoats: "Boats?isUsed=false&",
    usedBoats: "Boats?isUsed=true&",
    featuredInventory: "Boats?IsFeaturedInventory=true&",
    compareBoats: "Boats/compare?BoatIds=",
    boatDetails: "Boats/get-by-id?BoatID=",
    boatModelAPI: "Boats/get-boat-filters?IsUsed=false&DealerLocationID=",
    newsAPI: "News?",
    eventsAPI: "Events?",
    filterBoat: "Boats/get-boat-filters?",
    teamMembers: "TeamMembers?DealerLocationID=",
    createTrader: "DealerLocation/trader",
    blackwidowImages: "Boats/get-blackwidow-images?HIN=",
};
/**
 *
 * @param {*} key
 * @returns
 */
export default (key) => `${config.baseURL}${config[key]}`;